import { DEFAULT_TZ, localDate, localMinutes, localTime } from '@kaizen/shared';

/**
 * Relógio do app no navegador: segue o relógio do servidor (que respeita KAIZEN_NOW).
 * O deslocamento é medido no login e em /auth/me; com KAIZEN_NOW o relógio fica congelado.
 */
let offsetMs = 0;
let frozen: number | null = null;
let tz = DEFAULT_TZ;

export function syncServerClock(serverNowIso: string, opts: { frozen?: boolean } = {}) {
  const server = new Date(serverNowIso).getTime();
  offsetMs = server - Date.now();
  frozen = opts.frozen ? server : null;
}
export function setTimezone(t: string) {
  tz = t;
}
export function timezone() {
  return tz;
}
export function now(): Date {
  return new Date(frozen ?? Date.now() + offsetMs);
}
export function today(): string {
  return localDate(now(), tz);
}
export function nowHHMM(): string {
  return localTime(now(), tz);
}
export function nowMinutes(): number {
  return localMinutes(now(), tz);
}
